<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
<el-form :label-position="labelPosition" label-width="116px" :model="formLabelAlign" style="width:75%;" >
    <el-form-item label="所属系统">
         <el-select  clearable v-model="value" @change="SubordinateChange(value)" placeholder="请选择所属系统">
                    <el-option
                    v-for="item in SubordinateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    >
                    </el-option>
                </el-select>
    </el-form-item>
    <el-form-item label="点位类型">
         <el-select  clearable v-model="PointTypevalue" @change="PointTypeChange(PointTypevalue)" placeholder="请选择点位类型">
                    <el-option
                    v-for="item in PointTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
    </el-form-item>
    <el-form-item label="分类名称">
         <el-select  clearable v-model="ClassifyNamevalue" @change="ClassifyNameChange(ClassifyNamevalue)" placeholder="请选择分类名称">
                    <el-option
                    v-for="item in ClassifyNameList"
                    :key="item.id"
                    :label="item.typeName"
                    :value="item.id">
                    </el-option>
                </el-select>
    </el-form-item>
    <el-form-item label="正向巡查标准(每条请以' ；'结尾)">
      <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 10}" placeholder="请输入正向巡查标准"  v-model="ForwardText"></el-input>
    </el-form-item>
      <el-form-item label="反向巡查标准(每条请以' ；'结尾)">
      <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 10}" placeholder="请输入反向巡查标准"  v-model="ReverseText"></el-input>
    </el-form-item>
</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
 components: {},
  name: "InspectionStandardDialog",
  data() {
    return {
        dialogVisible: false,
        title:"标题",
        labelPosition:'right',
        formLabelAlign:{},

        SubordinateList:[],
        value:"",
        valueName:"",
        PointTypeList:[],
        PointTypevalue:"",
        PointTypeName:'',
        ClassifyNameList:[],
        ClassifyNamevalue:"",
        ClassifyName:"",

        ForwardText:"",
        ReverseText:"",
        rowId:"",
    };
  },
  watch:{
    title(val){
      if(val == "添加巡检标准"){
        this.ForwardText = ""
        this.ReverseText = ""
        this.value = ""
        this.rowId = ""
        this.PointTypevalue = ""
        this.ClassifyNamevalue = ""
        this.ClassifyNameList = ""
        this.SubordinateList = ""
      }
    }
  },
  methods: {
    SubordinateChange(res){
      for(let val of this.SubordinateList){
        if(val.value == res){
          this.valueName = val.label
              this.$http.get("/inspect/stand/getSpotType?system="+val.label).then((res)=>{
              let data = res.data
              let arr = []
              if(data.code == 200){
                for(let i = 0;i<data.data.length;i++){
                  let obj = {
                    "value":i,
                    "label":data.data[i]
                  }
                  arr.push(obj)
                }
                this.PointTypeList = arr
              }else{
                this.$message.error(data.msg)
              }
              })
        }
      }
    },
    PointTypeChange(res){
      for(let val of this.PointTypeList){
        if(val.value == res){
          this.PointTypeName = val.label
        }
      }
    },
    ClassifyNameChange(res){
      for(let val of this.ClassifyNameList){
        if(val.id == res){
          this.ClassifyName = val.typeName
        }
      }
    },

    modification(){
        if(this.title == "添加巡检标准"){
          let obj = {
              "field":this.valueName,
              "spotType":this.PointTypeName,
              "inspectType":this.ClassifyName,
              "inspectStandard":this.ForwardText,
              "inspectStandardEx":this.ReverseText
            }
          this.$http.post(this.$requestUrl.POST_STAND_SAVE,obj).then((res) => {
            let data = res.data
            if(data.code == 200){
              this.dialogVisible = false
              this.$emit("dialogVisible",false)
              this.$message({
                message: data.msg,
                type: 'success'
              });
            }else{
              this.$message.error(data.msg)
            }
          }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
          })
        }else{
            if(!isNaN(this.value)){
              for(let val of this.SubordinateList){
                if(this.value == val.value){
                  this.valueName = val.label
                }
              }
            }else{
              this.valueName = this.value
            }
            if(!isNaN(this.PointTypevalue)){
                for(let val of this.PointTypeList)  {
                  if(this.PointTypevalue == val.value){
                    this.PointTypeName = val.label
                  }
                }
            }else{
              this.PointTypeName = this.PointTypevalue
            }

            if(!isNaN(this.ClassifyNamevalue)){
              for(let val of this.ClassifyNameList){
                if(this.ClassifyNamevalue == val.id){
                  this.ClassifyName = val.typeName
                }
              }
            }else{
              this.ClassifyName = this.ClassifyNamevalue
            }
            let obj = {
              "id":this.rowId,
              "field":this.valueName,
              "spotType":this.PointTypeName,
              "inspectType":this.ClassifyName,
              "inspectStandard":this.ForwardText,
              "inspectStandardEx":this.ReverseText
            }
          this.$http.post(this.$requestUrl.POST_STAND_UPDATE,obj).then((res) => {
            let data = res.data
            if(data.code == 200){
              this.dialogVisible = false
              this.$emit("dialogVisible",false)
              this.$message({
                message: data.msg,
                type: 'success'
              });
            }else{
              this.$message.error(data.msg)
            }
          }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
          })


        }
    },
    handleClose(done) {
      this.dialogVisible = false
    },



  },
  mounted(){
    // this.estimate()
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {

  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>